import {Settings} from "luxon"

export default defineNuxtPlugin((nuxtApp) => {
    Settings.defaultLocale = nuxtApp.$i18n.locale.value
})
